import { css } from "@compiled/react";

import { media } from "@atlaskit/primitives/responsive";

import { ContentBlock, OneLinkProps } from "@/components/wpl/content-block/src";
import { Link } from "@/components/wpl/link/src";
import {
    TabGroup,
    IndividualTabPropsQuote,
    TabColorProps,
    TabContentTypes
} from "@/components/wpl/tab-group/src";
import { Row } from "@/libraries/wpl/foundations/src";

export interface PatternTabsQuoteProps {
    id: string;
    label: string;
    headerText: string;
    bodyText: string;
    tabs: IndividualTabPropsQuote[];
    colors?: TabColorProps;
    ctaProps?: OneLinkProps;
    linkPosition?: "top" | "bottom";
    className?: string;
    tabContentType?: TabContentTypes;
}

const StatsStyle = css({
    color: "#ffffff",
    padding: "64px 0",
    [media.only.sm]: {
        padding: "48px 0"
    },
    [media.below.sm]: {
        padding: "32px 0"
    }
});

const TabsWrapper = css({
    padding: "20px 0"
});

export const TabsQuote = ({
    id,
    label,
    headerText,
    bodyText,
    tabs,
    colors,
    ctaProps,
    linkPosition = "bottom",
    className,
    tabContentType = "quoteTextImage"
}: PatternTabsQuoteProps) => {
    return (
        <div className={className} css={StatsStyle}>
            <Row layout="10">
                <ContentBlock
                    className="tabs-quote-header-content-block"
                    headerText={headerText}
                    headerType="h2"
                    bodyText={bodyText}
                    isCentered={true}
                    ctaProps={
                        linkPosition == "top" && ctaProps?.primaryLinkProps
                            ? ctaProps
                            : {}
                    }
                />
            </Row>

            <div css={TabsWrapper} className="tabquote-tab-group-div">
                {/* @ts-ignore */}
                <TabGroup
                    colors={colors}
                    tabContentType={tabContentType}
                    tabs={tabs}
                    id={id}
                    label={label}
                />
            </div>

            {linkPosition == "bottom" && ctaProps?.primaryLinkProps ? (
                <Row>
                    <div style={{ textAlign: "center" }}>
                        <Link {...ctaProps.primaryLinkProps} />
                    </div>
                </Row>
            ) : null}
        </div>
    );
};
